// src/pages/ItemLedger/ItemLedgerSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchItemLedger } from "./ItemLedgerThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    itemId: null,
    fromDate: null,
    toDate: null,
  },
};

const itemLedgerSlice = createSlice({
  name: "itemLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchItemLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchItemLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchItemLedger.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = itemLedgerSlice.actions;
export default itemLedgerSlice.reducer;
